import app from '../containers/app/AppReducer';
import account from '../containers/delete-account/DeleteAccountReducer';
import devices from '../containers/devices/DevicesReducer';
import signature from '../containers/signature/SignatureReducer';
import brand from '../components/brand/BrandReducer';
import notifications from '../components/notifications/NotificationsReducer';
import confirmationModal from '../components/confirmation-modal/ConfirmationModalReducer';
import infoModal from '../containers/billing/components/edit-info/EditInfoReducer'
import informationModal from '../components/information-modal/InformationModalReducer';
import user from '../containers/login/LoginReducer';
import settings from '../containers/settings/SettingsReducer'
// import { Reducers } from '@int/rich-text-signature-redux';
import {combineReducers} from "redux";

import billing from "../containers/billing/BillingReducer"

import { reducer as form } from 'redux-form' //b
// import {rootReducer as ultimaDDManager} from '@int/react-manage-members';//b
import { i18nReducer as i18n } from 'react-redux-i18n';//b

export default {
    app,
    account,
    brand,
    confirmationModal,
    infoModal,
    informationModal,
    devices,
    notifications,
    signature,
    user,
    settings,
    billing, //B
    form,
    // ultimaDDManager,
    i18n
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js